import * as lodash from "lodash";
import styled, { css } from "styled-components";

import { elementSpacingMixin } from "uikit/styles";

import { TextProps, TitleProps, TypographyProps } from "./types";

export const TypographyElementBaseMixin = css<TypographyProps>`
  ${elementSpacingMixin};
  color: ${({ theme }) => theme.colors.colorsNew.gray["900"]};
  text-align: ${({ $align }) => $align ?? "left"};

  ${({ $noWrap }) =>
    $noWrap &&
    css`
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    `}

  ${({ $color }) =>
    $color &&
    css`
      color: ${({ theme }) => lodash.get(theme.colors.colorsNew, $color)};
    `}
`;

export const TextMixin = css<TextProps>`
  ${TypographyElementBaseMixin}
  ${({ $variant }) =>
    $variant === "secondary" &&
    css`
      color: ${({ theme }) => theme.colors.colorsNew.gray["600"]};
    `}
  font-size: ${({ theme, $fs }) => theme.size[$fs ?? "t16"]};
  font-weight: ${({ theme, $fw }) => theme.fontWeight[$fw ?? "regular"]};
  line-height: ${({ theme, $lh }) => theme.lineHeight[$lh ?? "lh140"]};
`;

export const TextBase = styled.p<TextProps>`
  ${TextMixin}
`;

export const TitleMixin = css<TitleProps>`
  ${TypographyElementBaseMixin}
  font-size: ${({ theme, $fs }) => theme.size[$fs ?? "h32"]};
  font-weight: ${({ theme, $fw }) => theme.fontWeight[$fw ?? "bold"]};
  line-height: ${({ theme, $lh }) => theme.lineHeight[$lh ?? "lh130"]};
`;

export const TitleBase = styled.h1<TitleProps>`
  ${TitleMixin}
`;
